import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { useState } from "react";
import { Link } from "@sainsburys-tech/luna-link";
import { More } from "@sainsburys-tech/luna-icons";

export const InformationPopup = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {props.dataPage===""?<Link onClick={() => setIsOpen(true)}>{props.linkText}</Link>:
       <>{props.initialValue}<More size="large" onClick={() => setIsOpen(true)} className="customColor" style={{color:""}}>{props.linkText} </More></>}

      {isOpen && (
        <Modal
          handleClose={() => setIsOpen(false)}
          open={isOpen}
          headingId="info-modal"
          closeElement="Close"
          className="infoModal"
          stickyHeader="Sticky Header"
        >
          <ModalHeading element="h5">{props.modalHeading}</ModalHeading>
          {props.children}
        </Modal>
      )}
    </>
  );
};
